import logFactory from '../../../utils/logger';
var log = logFactory('splitio-storage:localstorage');
var DEFINED = '1';

var SegmentCacheInLocalStorage = /*#__PURE__*/function () {
  function SegmentCacheInLocalStorage(keys) {
    this.keys = keys; // There is not need to flush segments cache like splits cache, since resetSegments receives the up-to-date list of active segments
  }

  var _proto = SegmentCacheInLocalStorage.prototype;

  _proto.addToSegment = function addToSegment(segmentName
  /*, segmentKeys: Array<string>*/
  ) {
    var segmentKey = this.keys.buildSegmentNameKey(segmentName);

    try {
      localStorage.setItem(segmentKey, DEFINED);
      return true;
    } catch (e) {
      log.error(e);
      return false;
    }
  };

  _proto.removeFromSegment = function removeFromSegment(segmentName
  /*, segmentKeys: Array<string>*/
  ) {
    var segmentKey = this.keys.buildSegmentNameKey(segmentName);

    try {
      localStorage.removeItem(segmentKey);
      return true;
    } catch (e) {
      log.error(e);
      return false;
    }
  }
  /**
   * Reset (update) the cached list of segments with the given list, removing and adding segments if necessary.
   *
   * @param {string[]} segmentNames list of segment names
   * @returns boolean indicating if the cache was updated (i.e., given list was different from the cached one)
   */
  ;

  _proto.resetSegments = function resetSegments(segmentNames) {
    var _this = this;

    var isDiff = false;
    var index; // Scan current values from localStorage

    var storedSegmentNames = Object.keys(localStorage).reduce(function (accum, key) {
      var segmentName = _this.keys.extractSegmentName(key);

      if (segmentName) accum.push(segmentName);
      return accum;
    }, []); // Extreme fast => everything is empty

    if (segmentNames.length === 0 && storedSegmentNames.length === segmentNames.length) return isDiff; // Quick path

    if (storedSegmentNames.length !== segmentNames.length) {
      isDiff = true;
      storedSegmentNames.forEach(function (segmentName) {
        return _this.removeFromSegment(segmentName);
      });
      segmentNames.forEach(function (segmentName) {
        return _this.addToSegment(segmentName);
      });
    } else {
      // Slowest path => we need to find at least 1 difference because
      for (index = 0; index < segmentNames.length && storedSegmentNames.indexOf(segmentNames[index]) !== -1; index++) {// TODO: why empty statement?
      }

      if (index < segmentNames.length) {
        isDiff = true;
        storedSegmentNames.forEach(function (segmentName) {
          return _this.removeFromSegment(segmentName);
        });
        segmentNames.forEach(function (segmentName) {
          return _this.addToSegment(segmentName);
        });
      }
    }

    return isDiff;
  };

  _proto.isInSegment = function isInSegment(segmentName
  /*, key: string*/
  ) {
    return localStorage.getItem(this.keys.buildSegmentNameKey(segmentName)) === DEFINED;
  };

  _proto.setChangeNumber = function setChangeNumber()
  /*segmentName: string, changeNumber: number*/
  {
    return true;
  };

  _proto.getChangeNumber = function getChangeNumber()
  /*segmentName: string*/
  {
    return -1;
  };

  _proto.registerSegment = function registerSegment()
  /*segment: string*/
  {
    return false;
  };

  _proto.registerSegments = function registerSegments()
  /*segments: Iterable<string>*/
  {
    return false;
  };

  _proto.getRegisteredSegments = function getRegisteredSegments() {
    return [];
  }
  /**
   * Removes list of segments from localStorage
   * @NOTE this method is not being used at the moment
   */
  ;

  _proto.flush = function flush() {
    log.info('Flushing MySegments data from localStorage'); // We cannot simply call `localStorage.clear()` since that implies removing user items from the storage
    // We could optimize next sentence, since it implies iterating over all localStorage items

    this.resetSegments([]);
  };

  return SegmentCacheInLocalStorage;
}();

export default SegmentCacheInLocalStorage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/storage/SegmentCache/InLocalStorage/index.js
// module id = 2766
// module chunks = 39